import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme) => ({
  newPillAnchor: {
    position: 'sticky',
    top: theme.spacing(1),
    zIndex: 2,
    height: 0,
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
  },
  newPill: {
    border: 0,
    borderRadius: 999,
    padding: '0.25rem 0.75rem',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: '0.75rem',
    cursor: 'pointer',
    boxShadow: theme.shadows[2],
  },
  groupList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  cardItem: {
    listStyle: 'none',
  },
}));
